export default __webpack_public_path__ + "static/media/(69).86f64de1.jpg";